import { createContext } from 'react'

import type { SessionResponse, SignedInUser } from '../api/contracts'

export interface AuthState {
  readonly user: SignedInUser | null
  /**
   * Açılıştaki sessiz yenileme yanıtlayana kadar `true`. Guard'lar bunu beklemek zorunda: oturumu
   * henüz geri yüklenmediği için kimliği doğrulanmış bir kullanıcıyı giriş ekranına yollamak,
   * o kişinin "rastgele oturumdan atıldım" diye yaşadığı bir hatadır.
   */
  readonly isRestoring: boolean
  readonly signIn: (session: SessionResponse) => void
  readonly signOut: () => Promise<void>
  /**
   * Aynı kişi için yeni bir jeton alır. Oturumdaki bir bayrak ürün tarafında değiştiğinde
   * (bugün: iki adımlı doğrulamanın kurulması) elde duran jeton eskimiş olur ve yenilenmeden
   * kullanıcı yaptığı işin karşılığını görmez.
   */
  readonly refresh: () => Promise<void>
}

/**
 * Sağlayıcıdan ayrı durur; böylece o modül yalnızca bileşen dışa verir. Aynı dosyadaki başka bir
 * export fast refresh'i bozar ve lint kapısı bunu yakalayacak şekilde ayarlı.
 */
export const AuthContext = createContext<AuthState | null>(null)
